import { COLLECTION_KEYS } from "../mobileMarketConstants";

export const MENU_COLLECTIONS_KEYS = [
    COLLECTION_KEYS.ALL,
    COLLECTION_KEYS.FAVORITES,
    COLLECTION_KEYS.FOREX,
    COLLECTION_KEYS.CRYPTO,
    COLLECTION_KEYS.STOCKS,
    COLLECTION_KEYS.MATERIALS,
    COLLECTION_KEYS.INDICES,
];
